import { apiDownload, apiFetch } from "./client";
import type { ReportDefinition, ReportFormat, ReportSchema } from "./types";

export interface RunReportRequest {
  params?: Record<string, unknown>;
  format?: ReportFormat;
  pageLayout?: "LANDSCAPE" | "PORTRAIT";
  pageWidth?: number;
  pageHeight?: number;
  data?: unknown;
  presentedBy?: string;
}

export const runtimeApi = {
  listReports: (folderId?: string, apiKey?: string) =>
    apiFetch<ReportDefinition[]>(
      `/v1/reports${folderId ? `?folderId=${encodeURIComponent(folderId)}` : ""}`,
      { apiKey }
    ),

  getSchema: (reportKey: string, apiKey?: string) =>
    apiFetch<ReportSchema>(`/v1/reports/${encodeURIComponent(reportKey)}/schema`, { apiKey }),

  resolveData: (reportKey: string, body: { data?: unknown }, apiKey?: string) =>
    apiFetch<Record<string, unknown>>(
      `/v1/reports/${encodeURIComponent(reportKey)}/resolve-data`,
      { method: "POST", body, apiKey }
    ),

  preview: (reportKey: string, body: RunReportRequest, apiKey?: string) =>
    apiFetch<string[]>(`/v1/reports/${encodeURIComponent(reportKey)}/preview`, {
      method: "POST",
      body,
      apiKey,
    }),

  download: (reportKey: string, body: RunReportRequest, apiKey?: string) =>
    apiDownload(`/v1/reports/${encodeURIComponent(reportKey)}/download`, body, apiKey),

  downloadZip: (reportKeys: string[], body: RunReportRequest, apiKey?: string) =>
    apiDownload(`/v1/reports/download-zip`, { reportKeys, ...body }, apiKey),

  /** Joins several reports into ONE PDF (vs downloadZip's separate-files-in-an-archive). */
  downloadMerged: (reportKeys: string[], params: Record<string, unknown> | undefined, apiKey?: string) =>
    apiDownload(`/v1/reports/download-merged`, { reportKeys, params }, apiKey),

  clearCache: (reportKey: string, apiKey?: string) =>
    apiFetch<void>(`/v1/reports/${encodeURIComponent(reportKey)}/cache`, {
      method: "DELETE",
      apiKey,
    }),
};
